import { makePromise } from './makePromise';

export class Deferred<T> {
	public readonly resolve!: (value: T | PromiseLike<T> | undefined) => void;
	public readonly reject!: (reason: any) => void;
	public readonly promise: Promise<T>;

	#resolved = false;
	#rejected = false;
	#done = false;

	get wasResolved(): boolean {
		return this.#resolved;
	}

	get wasRejected(): boolean {
		return this.#rejected;
	}

	get isDone(): boolean {
		return this.#done;
	}

	constructor(avoidUnhandledRejection = false) {
		this.promise = makePromise<T>((_resolve, _reject) => {
			(this as any).resolve = (value: T | PromiseLike<T>) => {
				if (this.#done) {
					return;
				}

				this.#resolved = true;
				this.#done = true;
				_resolve(value);
			};
			(this as any).reject = (err: any) => {
				if (this.#done) {
					return;
				}

				this.#rejected = true;
				this.#done = true;
				_reject(err);
			};
		});

		if (avoidUnhandledRejection) {
			this.promise.catch(() => {
				// noop
			});
		}
	}
}
